import { RpmLeaderboardEntry, TrainingLaunch, UserTrainingStats } from '../../domain/models/TrainingLaunch';
import { TrainingRepository } from '../../domain/repositories/TrainingRepository';
import { TrainingDataSource } from '../datasources/TrainingDataSource';
import {
  leaderboardEntryEntityToModel,
  trainingLaunchEntityToModel,
  userTrainingStatsEntityToModel,
} from '../entities/TrainingLaunchEntity';

export class TrainingRepositoryImpl implements TrainingRepository {
  constructor(private dataSource: TrainingDataSource) {}

  async insertLaunch(launch: TrainingLaunch): Promise<void> {
    await this.dataSource.insert(launch);
  }

  async getLeaderboard(sortBy?: string, limit?: number): Promise<RpmLeaderboardEntry[]> {
    const entities = await this.dataSource.getLeaderboard(sortBy, limit);
    return entities.map(leaderboardEntryEntityToModel);
  }

  async getUserLaunches(userId: string): Promise<TrainingLaunch[]> {
    const entities = await this.dataSource.getUserLaunches(userId);
    return entities.map(trainingLaunchEntityToModel);
  }

  async getUserTrainingStats(userId: string): Promise<UserTrainingStats | null> {
    const entity = await this.dataSource.getUserTrainingStats(userId);
    if (!entity) return null;
    return userTrainingStatsEntityToModel(entity);
  }
}
